import { BlankLayout } from '@/components/layouts';

export default {
  path: '/material',
  name: 'Material',
  component: BlankLayout,
  meta: { module: '素材' },
  children: [
    {
      path: '/material/single-model/:id',
      name: 'Material.SingleModel.Details',
      component: () => import(/* webpackChunkName: 'material-single-model-details' */ '../../views/material/SingleModelDetails.vue'),
      meta: { title: '单体模型详情' },
    },
    {
      path: '/material/combined-model/:id',
      name: 'Material.CombinedModel.Details',
      component: () => import(/* webpackChunkName: 'material-combined-model-details' */ '../../views/material/CombinedModelDetails.vue'),
      meta: { title: '组合模型详情' },
    },
    {
      path: '/material/scene-model/:id',
      name: 'Material.SceneModel.Details',
      component: () => import(/* webpackChunkName: 'material-scene-model-details' */ '../../views/material/SceneModelDetails.vue'),
      meta: { title: '场景模型详情' },
    },
    {
      path: '/material/column/:id',
      name: 'Material.Column.Details',
      component: () => import(/* webpackChunkName: 'material-column-details' */ '../../views/material/ColumnDetails.vue'),
      meta: { title: '素材专栏详情' },
    },
  ],
};
